$(document).on('click', "#generate_preview", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('#busy_modal').modal({ backdrop: 'static', keyboard: false })
    // $('#busy_modal').modal('toggle')

    // 400 * 2000... ~ 10min
    let max_counter = 400;

    // <li><%=link_to 'Generate Previews',  "/pages/generate_previews", remote:true, data: {disable_with: "<i class='fa fa-spinner fa-spin'></i> Building Preview..."}  %> </li>
    $.ajax({
        url: '/pages/generate_previews',
        type: "GET",
        timeout: 1000,
        success: function (response) { console.log(response); },
        error: function (xmlhttprequest, textstatus, message) { console.log(textstatus); }
    });

    setTimeout(check_preview_done, 3000);

    function check_preview_done() {
        max_counter -= 1
        if (max_counter < 0) {
            $('#busy_modal').modal('toggle')
            alert('Unable to create preview right now')
            return;
        }

        $.get('/pages/check_release', function (data) {
            console.log(data)
            if (data.azure == 1) {
                html_page = document.getElementById("preview-link")
                html_page.innerHTML = data.html
                $('#busy_modal').modal('hide')
            } else {
                setTimeout(check_preview_done, 2000);
            }
        })
    }
    return false;
})
$(document).on('click', "#generate_preview_tree", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('#busy_modal').modal({ backdrop: 'static', keyboard: false })
    // $('#busy_modal').modal('toggle')

    // 400 * 2000... ~ 10min
    let max_counter = 400;
    let page_id = $(this).data('pageid')

    $.ajax({
        url: '/pages/generate_previews_tree/',
        data: { page: { export_page_id: page_id } },
        type: 'POST',
        timeout: 1000,
        success: function (response) {
            console.log(response)
        },
        error: function (xmlhttprequest, textstatus, message) {
            console.log(textstatus)
        },
    })

    setTimeout(check_preview_done, 3000);

    function check_preview_done() {
        max_counter -= 1
        if (max_counter < 0) {
            $('#busy_modal').modal('toggle')
            alert('Unable to create preview right now')
            return;
        }

        $.get('/pages/check_release', function (data) {
            console.log(data)
            if (data.azure == 1) {
                html_page = document.getElementById("preview-link")
                html_page.innerHTML = data.html
                $('#busy_modal').modal('hide')
            } else {
                setTimeout(check_preview_done, 2000);
            }
        })
    }
    return false;
})